var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Card from 'antd/lib/card';
import Col from 'antd/lib/grid/col';
import Icon from 'antd/lib/icon';
import Row from 'antd/lib/grid/row';
import 'antd/lib/card/style/index.css';
import 'antd/lib/grid/style/index.css';
import Page from '../../templates/Page';
import ListCategory from './ListCategory';
import ButtonAction from '../../components/utilities/ButtonAction';
var ListCategoryPage = (function (_super) {
    __extends(ListCategoryPage, _super);
    function ListCategoryPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListCategoryPage.prototype.render = function () {
        return (React.createElement(Page, { documentTitle: "Categories | " + this.props.store.event.nameShort, pageTitle: 'Categories', pageAction: (React.createElement(ButtonAction, null,
                React.createElement(Link, { to: "/event/" + this.props.store.event.subdomain + "/categories/new" },
                    React.createElement(Icon, { type: 'file-add' }),
                    " Setup new category"))) },
            React.createElement(Row, { gutter: 24 },
                React.createElement(Col, { xs: 24, md: 24 },
                    React.createElement(Card, { className: 'tableCard' },
                        React.createElement(ListCategory, { categories: this.props.store.categories, rounds: this.props.store.rounds }))))));
    };
    return ListCategoryPage;
}(React.Component));
var mapStateToProps = function (state) { return ({
    store: {
        user: state.workspaceMain.user && state.workspaceMain.user.data[0],
        event: state.workspaceEvent.event && state.workspaceEvent.event.data[0],
        categories: state.workspaceEvent.categories && state.workspaceEvent.categories.data,
        rounds: state.workspaceEvent.rounds && state.workspaceEvent.rounds.data,
    },
}); };
export default connect(mapStateToProps)(ListCategoryPage);



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/ListCategoryPage/index.tsx
// module id = 1084
// module chunks = 0